
export default class TransportationPermissionExtra {
  id: number;
  name: string;
  price: number;
  extraId?: number;
  vatPercentage?: number;
  passengerTransportationPermissionId: number;

  constructor() {

  }

  copyFromApi(options) {
    this.id = options && options.id ? options.id : 0;
    this.name = options && options.name ? options.name : "";
    this.price = options && options.price ? options.price : 0;
    this.extraId = options && options.extraId ? options.extraId : null;
    this.vatPercentage = options && options.vatPercentage ? options.vatPercentage : null;
    this.passengerTransportationPermissionId = options && options.passengerTransportationPermissionId ? options.passengerTransportationPermissionId : 0;

    return this;
  }

}
